import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Typography,
} from '@mui/material'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import CreatePlatformDataSheetHelpDialog from './CreatePlatformDataSheetHelpDialog'
import CreatePlatformDataSheetSuccessModal from './CreatePlatformDataSheetSuccessModal'
import {
  clearMessage,
  createPlatformDataSheet,
} from '../../store/CreateSmartsheets/actionCreator'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'

export class GeneratePlatformDataSheetsTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonEnabled: false,
      dataSheetName: '',
      eventsMessage: '',
      helpOpen: false,
      smartsheetData: [],
      statusOpen: false,
    }
    this.createPlatformDataSheet = this.createPlatformDataSheet.bind(this)
    this.handleHelpClose = this.handleHelpClose.bind(this)
    this.handleHelpOpen = this.handleHelpOpen.bind(this)
    this.handleStatusClose = this.handleStatusClose.bind(this)
    this.resetForm = this.resetForm.bind(this)
    this.validateForm = this.validateForm.bind(this)
  }

  async componentDidMount() {
    await this.props.clearMessage()
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Platform Data Sheet Tab',
        'Platform Data Sheet Tab Load',
        userInfo,
      )
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.smartsheetData !== nextProps.smartsheetData ||
      this.props.eventsMessage !== nextProps.eventsMessage
    ) {
      this.setState({
        smartsheetData: nextProps.smartsheetData,
        eventsMessage: nextProps.eventsMessage,
      })
    }
  }

  createPlatformDataSheet = (event) => {
    const { userInfo } = this.props
    handleFireflySendClickEvent(
      'CLICK',
      'Platform Data Sheet Tab',
      'Platform Data Sheet - Submit',
      userInfo,
    )
    event.preventDefault()
    this.props.clearMessage()
    this.props.createPlatformDataSheet(this.state.dataSheetName)
    this.setState({ statusOpen: true })
    this.resetForm()
  }

  handleHelpClose() {
    this.setState({ helpOpen: false })
  }

  handleHelpOpen() {
    this.setState({ helpOpen: true })
  }

  handleStatusClose() {
    this.setState({
      statusOpen: false,
    })
  }

  resetForm = () => {
    this.setState({
      dataSheetName: '',
      buttonEnabled: false,
    })
  }

  validateForm = () => {
    if (this.state.dataSheetName !== '') {
      this.setState({ buttonEnabled: true })
    } else {
      this.setState({ buttonEnabled: false })
    }
  }

  render() {
    let modalTitle
    if (this.state.eventsMessage === 'Smartsheet created!') {
      modalTitle = 'Success'
    } else if (
      this.state.eventsMessage !== undefined &&
      this.state.eventsMessage.length > 1 &&
      this.state.eventsMessage !== 'Smartsheet created!'
    ) {
      modalTitle = 'Error'
    } else {
      modalTitle = ''
    }

    return (
      <CardContent
        style={{
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto',
        }}
      >
        <CardActions style={{ width: '100%' }}>
          <Grid
            item
            size={{ xs: 12 }}
            style={{
              marginTop: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography gutterBottom>
              Enter the name for the Platform Data Sheet you wish to create.
            </Typography>
            <Tooltip title={'Help'}>
              <IconButton onClick={this.handleHelpOpen} size="large">
                <HelpOutlineIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </CardActions>
        <form
          onSubmit={(event) =>
            this.createPlatformDataSheet(event, this.props.user)
          }
          style={{
            alignItems: 'stretch',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid
            container
            style={{
              width: '100%',
              height: '100%',
              alignItems: 'stretch',
              display: 'flex',
            }}
          >
            <Grid item size={{ xs: 14, md: 10 }}>
              <TextField
                htmlFor="dataSheetName"
                type="text"
                variant="standard"
                value={this.state.dataSheetName}
                placeholder="AP Chromebox"
                label="Platform Data Sheet Name"
                required
                style={{ width: '100%' }}
                onChange={(event) =>
                  this.setState(
                    { dataSheetName: event.target.value },
                    function () {
                      this.validateForm()
                    },
                  )
                }
                slotProps={{
                  className: 'redUnderline',
                }}
              />
            </Grid>
            <br />
            <CardActions
              style={{
                width: '100%',
                height: '30%',
              }}
            >
              <Grid
                item
                size={{ xs: 12 }}
                style={{
                  marginTop: 0,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'start',
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={!this.state.buttonEnabled}
                >
                  Submit
                </Button>
              </Grid>
            </CardActions>
          </Grid>
        </form>
        <CreatePlatformDataSheetHelpDialog
          open={this.state.helpOpen}
          handleHelpClose={this.handleHelpClose}
        />
        <CreatePlatformDataSheetSuccessModal
          open={this.state.statusOpen}
          handleClose={this.handleStatusClose}
          eventsMessage={this.state.eventsMessage}
          smartsheetData={this.state.smartsheetData}
          title={modalTitle}
        />
      </CardContent>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    eventsMessage: state.createSmartsheets.eventsMessage,
    smartsheetData: state.createSmartsheets.smartsheetData,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  clearMessage,
  createPlatformDataSheet,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeneratePlatformDataSheetsTab)
